function initTermsValidation() {

  const forms = document.querySelectorAll('form[action="/cart"]');

  forms.forEach(form => {

    if (form.dataset.termsInitialized) return;
    form.dataset.termsInitialized = "true";

    form.addEventListener('submit', function(e) {

      const checkbox = form.querySelector('#accept-terms');
      const error = form.querySelector('#terms-error');

      if (checkbox && !checkbox.checked) {
        e.preventDefault();
        if (error) error.style.display = 'block';
        checkbox.focus();
      }

    });
  });
}

document.addEventListener("DOMContentLoaded", initTermsValidation);
document.addEventListener("shopify:section:load", initTermsValidation);


// function initTermsValidation() {

//   const cartForm = document.querySelector('form[action="/cart"]');
//   if (!cartForm) return;

//   const checkbox = cartForm.querySelector('#accept-terms');
//   const error = cartForm.querySelector('#terms-error');

//   if (!checkbox) return;

//   cartForm.addEventListener('submit', function(e) {
//     if (!checkbox.checked) {
//       e.preventDefault();
//       if (error) error.style.display = 'block';
//       checkbox.focus();
//     }
//   });
// }

// // Ejecutar al cargar
// document.addEventListener("DOMContentLoaded", function() {
//   initTermsValidation();
// });

// // Ejecutar también cuando Shopify actualiza el cart drawer
// document.addEventListener('shopify:section:load', function() {
//   initTermsValidation();
// });



// document.addEventListener("DOMContentLoaded", function () {

//   function setupTermsValidation() {
//     const checkoutButton = document.querySelector('a[href="/checkout"], button[name="checkout"]');
//     const checkbox = document.getElementById("accept-terms");
//     const error = document.getElementById("terms-error");

//     if (!checkoutButton || !checkbox) return;

//     checkoutButton.addEventListener("click", function (e) {
//       if (!checkbox.checked) {
//         e.preventDefault();
//         error.style.display = "block";
//         checkbox.focus();
//       }
//     });
//   }

//   setupTermsValidation();
// });


// document.addEventListener("DOMContentLoaded", function () {
//     console.log('Run custom validations');
//     waitForDrawerAndObserve();
//     addCartPageTermsValidation();
// });

function addDrawerTermsValidation() {
    const drawerCheckbox = document.getElementById("drawer-accept-terms");
    const drawerCheckoutBtn = document.getElementById("CartDrawer-Checkout");
    const drawerErrorMsg = document.getElementById("drawer-terms-error");

    if (drawerCheckbox && drawerCheckoutBtn && drawerErrorMsg) {
        if (drawerCheckoutBtn.dataset.termsHandlerAttached === "true") return;
            drawerCheckoutBtn.disabled = true;
            drawerCheckbox.addEventListener("change", function () {
            if (drawerCheckbox.checked) {
                drawerCheckoutBtn.disabled = false;
                drawerErrorMsg.style.display = "none";
            } else {
                drawerCheckoutBtn.disabled = true;
            }
        });

        drawerCheckoutBtn.addEventListener("click", function (e) {
            if (!drawerCheckbox.checked) {
              e.preventDefault();
              drawerErrorMsg.style.display = "block";
            }
        });
        drawerCheckoutBtn.dataset.termsHandlerAttached = "true";
    }
}

function addCartPageTermsValidation() {
    const cartCheckbox = document.getElementById("accept-terms");
    const cartCheckoutBtn = document.querySelector('form[action$="/cart"] button[name="checkout"]');
    const cartErrorMsg = document.getElementById("terms-error");

    if (cartCheckbox && cartCheckoutBtn && cartErrorMsg) {
        if (cartCheckoutBtn.dataset.termsHandlerAttached === "true") return;

        cartCheckoutBtn.disabled = true;

        cartCheckbox.addEventListener("change", function () {
        if (cartCheckbox.checked) {
            cartCheckoutBtn.disabled = false;
            cartErrorMsg.classList.remove("show");
        } else {
            cartCheckoutBtn.disabled = true;
        }
        });

        cartCheckoutBtn.addEventListener("click", function (e) {
            if (!cartCheckbox.checked) {
                e.preventDefault();
                cartErrorMsg.classList.add("show");
            }
        });

        cartCheckoutBtn.dataset.termsHandlerAttached = "true";
    }
}

// Observa el drawer cuando aparezca
function waitForDrawerAndObserve() {
    const checkDrawerInterval = setInterval(() => {
        const drawer = document.getElementById("CartDrawer");
        if (drawer) {
        console.log("✅ Drawer encontrado, inicializando observador...");
        clearInterval(checkDrawerInterval);

        const observer = new MutationObserver(() => {
            addDrawerTermsValidation();
        });

        observer.observe(drawer, { childList: true, subtree: true });

        // Ejecuta una vez por si ya está cargado
        addDrawerTermsValidation();
        } else {
        //console.log("⏳ Esperando a que CartDrawer aparezca...");
        }
    }, 3000); // revisa cada 300ms
}